import React, { type FC } from 'react';
import { FormattedMessage } from 'react-intl';

import Button from '@atlaskit/button/default/button';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import Box from '@atlaskit/primitives/box';
import { xcss } from '@atlaskit/primitives/xcss';
import { token } from '@atlaskit/tokens';

import { expVal } from '@confluence/feature-experiments';

import { i18n } from '../controlled/ControlledShareButton.tsx';

const iconSkeletonStyle = xcss({
	width: '16px',
	height: '16px',
	borderRadius: 'radius.xsmall',
	background: token('color.background.accent.gray.subtlest.hovered'),
});

const iconSkeletonWithMarginsStyle = xcss({
	width: '16px',
	height: '16px',
	borderRadius: 'radius.xsmall',
	marginLeft: 'space.050',
	marginRight: 'space.025',
	background: token('color.background.accent.gray.subtlest.hovered'),
});

const SkeletonGlyph = () => (
	<Box
		testId="icon-skeleton"
		xcss={
			expVal('platform_editor_stabilise_ssr_vr_tests', 'isEnabled', false)
				? iconSkeletonStyle
				: iconSkeletonWithMarginsStyle
		}
	/>
);

export const ShareAndRestrictButtonPlaceholder: FC<{}> = () => (
	<Button
		appearance="default"
		iconBefore={() => <SkeletonGlyph />}
		onClick={() => {}}
		isDisabled
		testId="share-and-restrict-button-placeholder"
	>
		<FormattedMessage {...i18n.share} />
	</Button>
);
